import { BASE_URL } from "static/constants";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getReminderLogs } from "app/services/transmission/patient";

export const subscriptionLogApi = createApi({
  reducerPath: "subscriptionLogApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    fetchReminderLogs: builder.query({
      queryFn: ({ patientId, type, page, pageSize, search }) => {
        return {
          data: getReminderLogs({ patientId, type, page, pageSize, search }),
        };
      },
    }),
  }),
});

export const { useFetchReminderLogsQuery } = subscriptionLogApi;
